export const getCachedData = <T>(key: string): T | null => {
  try {
    const item = window.localStorage.getItem(key);
    if (item) {
      return JSON.parse(item) as T;
    }
    return null;
  } catch (error) {
    console.warn(`Error reading localStorage key "${key}":`, error);
    return null;
  }
};

export const setCachedData = <T>(key: string, data: T): void => {
  try {
    window.localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.warn(`Error setting localStorage key "${key}":`, error);
  }
};
